import { connect } from 'react-redux';

import { VODCSSModules } from 'shared/utils/wix-connect';

import {
  shouldShowChannelCover,
} from 'widget/utils/overlay-buttons-utils';

import { isVideoPlaying, isVideoPaused } from 'widget/selectors/video-playback-status';

import ResizedImage from 'shared/components/resized-image/resized-image';
import ExternalPlayer from './new-player-external';
import InternalPlayer from './new-player-internal';

import styles from './new-player.styl';


@connect(state => ({
  isVideoPlaying: isVideoPlaying(state),
  isVideoPaused: isVideoPaused(state),
}))
@VODCSSModules(styles)
export default class Player extends React.Component {

  static propTypes = {
    isVideoPlaying: React.PropTypes.bool,
    isVideoPaused: React.PropTypes.bool,

    appSettings: React.PropTypes.object,
    channelData: React.PropTypes.object,
    canShowChannelCover: React.PropTypes.bool,
    children: React.PropTypes.any,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    videoItem: React.PropTypes.object.isRequired,
    videoUrls: React.PropTypes.object,
    showPoster: React.PropTypes.bool,
  };

  static defaultProps = {
    showPoster: true,
  };

  get styles() {
    const { width, height } = this.props;
    return {
      width,
      height,
    };
  }

  get player() {
    const { videoItem: { mediaExternUrl } } = this.props;
    const isExternal = Boolean(mediaExternUrl);

    const PlayerComponent = isExternal ? ExternalPlayer : InternalPlayer;

    const props = _.omit(this.props, 'intl', 'styles');

    return <PlayerComponent {...props} />;
  }

  get isChannelCoverView() {
    const { appSettings, canShowChannelCover } = this.props;
    // Todo: move to connect
    return shouldShowChannelCover(appSettings, canShowChannelCover);
  }

  // TEMP SOLUTION FOR OVERLAYS
  get coverUrl() {
    const { videoItem, channelData } = this.props;

    let coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

    if (this.isChannelCoverView) {
      coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
    }

    return coverUrl;
  }

  get cover() {
    const { width, height, isVideoPaused, isVideoPlaying, showPoster } = this.props;

    if (!showPoster || isVideoPaused || isVideoPlaying) {
      return null;
    }

    return (
      <ResizedImage className={styles.cover}
                    src={this.coverUrl}
                    width={width}
                    height={height} />
    );
  }

  get overlay() {
    const { children, isVideoPaused, isVideoPlaying } = this.props;

    if (isVideoPaused || isVideoPlaying) {
      return null;
    }

    return children;
  }

  render() {
    return (
      <section styleName="player"
               style={this.styles}>
        {this.cover}
        {this.overlay}
        {this.player}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/new-player.js